<template>
  <div :class="`story-with-ad story-with-ad--ad-${adPosition}`">
    <div
      v-if="adPosition && adPosition !== 'none'"
      class="story-with-ad__ad"
    >
      <ad-slot
        mapping="halfpage"
      />
    </div>
    <div class="story-with-ad__content-wrapper">
      <div class="story-with-ad__content">
        <h2
          class="story-with-ad__heading"
          :style="`color: ${headingColor}`"
        >{{ heading }}</h2>
        <div
          class="story-with-ad__copy"
          v-html="copy"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AdSlot from '@/components/Ads/AdSlot.vue';

export default {
  name: 'StoryWithAd',
  components: {
    AdSlot,
  },
  props: {
    heading: {
      type: String,
      default: '',
    },
    headingColor: {
      type: String,
      default: '',
    },
    copy: {
      type: String,
      default: '',
    },
    adPosition: {
      type: String,
      default: 'None',
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_story-with-ad';
</style>

<style lang="scss"> // no scoped - to reach HTML content
  .story-with-ad p {
    margin-bottom: $spacing * 3;
    line-height: 1.6;
  }
</style>
